import type { GoogleTagManagerKey } from "@warrenio/api-spec/spec.oats.gen";

export const googleTagManagerExample: GoogleTagManagerKey = {
    gtm_key: "GTM-xxxxxxx",
};
